import React from 'react';
import {Button, Grid} from '@material-ui/core';

interface Props {
    handleClose: () => void;
    handleSubmit: () => void;
    btnText: string;
    disable: boolean;
}

function FileImportFooter({handleClose, handleSubmit, btnText, disable}: Props) {
    return (
        <Grid container direction="row" justify="flex-end" alignItems="center">
            <Button className="import__dropzone-btn" onClick={handleClose}>
                Cancel
            </Button>
            <Button
                className="import__dropzone-btn primary"
                onClick={handleSubmit}
                disabled={disable}
            >
                {btnText}
            </Button>
        </Grid>
    );
}

export default FileImportFooter;
